import './styles.css';

export const Line = () => {
    return <div className="line" />;
};
